import { sliceNewRewardsCount } from '@/features/raundSlice'
import { raundUrl } from '@/lib/custom'
import { useFetchGet } from '@/lib/useFetch'
import { useDispatch } from 'react-redux'

export const usePresentCount = () => {
  const dispatch = useDispatch()
  const { getWithAuth: getUserPresents } = useFetchGet<Api.PresentsCheckResBody>({})
  const setPresentCount = async () => {
    try {
      const presentsCheckResBody: Api.PresentsCheckResBody = await getUserPresents(`${raundUrl.presents}/check/`)
      if (presentsCheckResBody) {
        const presentsCount = presentsCheckResBody.count
        dispatch(sliceNewRewardsCount(presentsCount))
      }
    } catch (error) {}
  }
  return { setPresentCount }
}
